import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Row, Col, Form, FormGroup, ControlLabel } from "react-bootstrap";
import { TextField, NumberField, SelectField } from "../../Shared/FormHelpers";
import Editor from "../../Shared/Editor";
import { Loader } from "../../Shared";
import {
  ButtonStyle,
  Label,
  StyledFormControl,
  FieldContainer,
} from "../../Styles";
import {
  Container,
  SectionTitle,
  DescriptionLabel,
  CategoryLabel,
  CategoryFieldContainer,
  LimitedAccess,
  EditorWrapper,
} from "../Styles/JobForm.styles";

const JobForm = ({
  user,
  handleChange,
  travelTypes,
  handleItemClick,
  telecomuteOptions,
  isNew,
  hasJobCredits,
  handleSubmit,
  handleCancel,
  handleUpdate,
  total,
  allPositionTypes,
  positionTypes,
  updatePending,
  createPending,
  stateData: {
    products,
    travel,
    jobLength,
    payRate,
    state,
    country,
    city,
    productId,
    description,
    applyEmail,
    title,
    jobLoaded,
    telecomute,
    zipcode,
    countries,
    regions: regionProps,
    salary,
  },
}) => {
  const regions = regionProps?.length ? regionProps : [country];
  return (
    <Container>
      <SectionTitle>
        Job Postings
        {user && (
          <div className="pull-right">
            job post credits: {user.job_credits.length}
          </div>
        )}
      </SectionTitle>
      {jobLoaded && (
        <Form name="jobpostForm">
          <section>
            <Row>
              <Col sm={6}>
                <TextField
                  placeholder="ex: Ruby on Rails Developer"
                  title="Title"
                  name="title"
                  onChange={handleChange}
                  value={title}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <DescriptionLabel componentClass={ControlLabel}>
                    Description
                  </DescriptionLabel>
                  <EditorWrapper>
                    <Editor onChange={handleChange} value={description} />
                  </EditorWrapper>
                </FormGroup>
              </Col>
            </Row>
          </section>
          <section>
            <Row>
              <Col md={12}>
                <SectionTitle>Application Method</SectionTitle>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <TextField
                  placeholder="your@email.com"
                  title="Email"
                  name="applyEmail"
                  onChange={handleChange}
                  value={applyEmail || ""}
                  required
                />
              </Col>
            </Row>
          </section>
          <section>
            <Row>
              <Col md={12}>
                <SectionTitle>Location</SectionTitle>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <SelectField
                  options={Array.from(new Set(countries)).sort((a, b) => b - a)}
                  style={{ background: "initial", height: 54 }}
                  title="Country"
                  name="country"
                  onChange={handleChange}
                  value={country}
                  label
                />
              </Col>

              <Col md={6}>
                <SelectField
                  options={Array.from(new Set(regions)).sort((a, b) => b - a)}
                  style={{ background: "initial", height: 54 }}
                  title="State or Region"
                  name="state"
                  onChange={handleChange}
                  value={state}
                  label
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextField
                  placeholder="Charlotte"
                  title="City"
                  name="city"
                  onChange={handleChange}
                  value={city}
                />
              </Col>
              <Col md={6}>
                <NumberField
                  placeholder="12345"
                  title="Zipcode"
                  name="zipcode"
                  onChange={handleChange}
                  value={zipcode}
                  required
                />
              </Col>
            </Row>
            {!isNew && (
              <Row style={{ marginBottom: 100 }}>
                <Col md={4}>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={handleUpdate}
                  >
                    Update
                  </ButtonStyle>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </ButtonStyle>
                </Col>
              </Row>
            )}
          </section>
          <section>
            <Row>
              <Col md={12}>
                <SectionTitle>Compensation & Travel</SectionTitle>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <CategoryLabel>Position Type</CategoryLabel>
                  <CategoryFieldContainer>
                    <Select
                      className="custom-dropdown"
                      value={
                        positionTypes &&
                        [...new Set(positionTypes)].map((position) => ({
                          value: position,
                          label: position,
                        }))
                      }
                      options={allPositionTypes}
                      onChange={handleItemClick}
                      isMulti
                      isSearchable
                      placeholder="Select Position Type"
                    />
                  </CategoryFieldContainer>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <CategoryLabel>Pay Rate</CategoryLabel>
                  <CategoryFieldContainer>
                    <StyledFormControl
                      title="Pay Rate"
                      type="number"
                      placeholder="55"
                      className="form-control"
                      name="payRate"
                      onChange={handleChange}
                      value={payRate}
                      required
                    />
                    <div className="alert alert-danger hide">
                      Please enter valid value.
                    </div>
                  </CategoryFieldContainer>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <CategoryLabel>Length (Months)</CategoryLabel>
                  <CategoryFieldContainer>
                    <StyledFormControl
                      type="number"
                      placeholder="12"
                      className="form-control"
                      name="jobLength"
                      onChange={handleChange}
                      value={jobLength}
                    />
                    <div className="alert alert-danger hide">
                      Please enter valid value.
                    </div>
                  </CategoryFieldContainer>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <TextField
                  style={{ background: "initial", height: 54 }}
                  placeholder="70000"
                  name="salary"
                  title="Salary(p.a)"
                  onChange={handleChange}
                  value={salary}
                  label
                  required
                />
              </Col>
              <Col md={4}>
                <SelectField
                  options={travelTypes}
                  style={{ background: "initial", height: 54 }}
                  name="travel"
                  title="Travel"
                  onChange={handleChange}
                  value={travel}
                  label
                  required
                />
              </Col>
              <Col md={4}>
                <SelectField
                  options={telecomuteOptions}
                  style={{ background: "initial", height: 54 }}
                  name="telecomute"
                  title="Telecomute"
                  onChange={handleChange}
                  value={telecomute}
                  label
                  required
                />
              </Col>
            </Row>
            {isNew && hasJobCredits && (
              <Row style={{ marginBottom: 100 }}>
                <Col md={3}>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={handleSubmit}
                  >
                    Post Job
                  </ButtonStyle>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </ButtonStyle>
                </Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "4rem",
                  }}
                >
                  <Loader width="25px" height="25px" show={createPending} />
                </div>
              </Row>
            )}
            {!isNew && (
              <Row style={{ marginBottom: 100 }}>
                <Col md={3}>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={handleUpdate}
                  >
                    Update
                  </ButtonStyle>
                  <ButtonStyle
                    type="button"
                    style={{ marginLeft: 14 }}
                    className="btn btn-primary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </ButtonStyle>
                </Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "4rem",
                  }}
                >
                  <Loader width="25px" height="25px" show={updatePending} />
                </div>
              </Row>
            )}
          </section>
          <section>
            {isNew && !hasJobCredits && (
              <div>
                <Row>
                  <Col md={6}>
                    <SectionTitle>Checkout</SectionTitle>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label>Job Posts</label>
                      <FieldContainer>
                        <SelectField
                          options={
                            products.filter(
                              (p) => p.category !== "subscription"
                            ) || []
                          }
                          style={{ background: "initial", height: 54 }}
                          name="productId"
                          onChange={handleChange}
                          value={productId}
                          required
                        />
                      </FieldContainer>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <Label>Order Total:</Label>
                    <FieldContainer
                      style={{
                        position: "relative",
                        top: 14,
                        marginBottom: 40,
                      }}
                    >
                      {total}
                    </FieldContainer>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <LimitedAccess className="clearfix">
                      +Includes LIMITED access to our resume database!
                    </LimitedAccess>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ButtonStyle
                      type="button"
                      style={{ marginLeft: 14 }}
                      className="btn btn-primary"
                      onClick={handleSubmit}
                    >
                      Checkout
                    </ButtonStyle>
                    <ButtonStyle
                      type="button"
                      style={{ marginLeft: 14 }}
                      className="btn btn-primary"
                      onClick={handleCancel}
                    >
                      Cancel
                    </ButtonStyle>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <SectionTitle>Pricing Information</SectionTitle>
                    <div className="main_div">
                      <div className="price_table">
                        {products &&
                          products
                            .filter((p) => p.category !== "subscription")
                            .map((option, i) => {
                              if (option.display === undefined) {
                                return <p key={i}>{option.name}</p>;
                              }
                              return <p key={i}>{option.display}</p>;
                            })}
                      </div>
                      <div className="price_table big">
                        <p>
                          <strong>Need More Jobs?</strong>
                          &nbsp;
                          <Link className="green_btn" to="/#">
                            Contact Us
                          </Link>
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <SectionTitle>Special Offer:</SectionTitle>
                    <p className="left">
                      Get Free Limited Access to QuirkyCoders's resume and
                      social profile database with each job post!
                      <br />
                      <span>
                        (Access is restricted to 10 candidate profile views)
                      </span>
                    </p>
                  </Col>
                </Row>
              </div>
            )}
          </section>
        </Form>
      )}
    </Container>
  );
};

export default JobForm;
